import React from 'react';
import Error from 'next/error';

import Head from 'next/head';
import R from '../src/lib/routes';
import { NextSeo } from 'next-seo';
import { fallbackImageInfo, createFrontendPageUrl } from '../src/lib/selectors';
import { getCareers } from '../src/lib/backend';
import CareersPage from '../src/components/careers/CareersPage';
import i18n from '../src/translations/i18n';

const careersPage = ({ error, ...passProps }) => {
  if (error) {
    return <Error statusCode={error.code} />;
  }

  return (
    <>
      <Head>
        <meta name="description" content={i18n.careersPageSEODescription} key="description" />
        <title>{i18n.careersPageSEOTitle}</title>
      </Head>
      <NextSeo
        openGraph={{
          url: createFrontendPageUrl(R.careers),
          locale: 'en_US',
          title: i18n.careersPageSEOTitle,
          description: i18n.careersPageSEODescription,
          type: 'website',
          images: [fallbackImageInfo],
          site_name: i18n.careersPageSiteName,
        }}
      />
      <CareersPage {...passProps} />
    </>
  );
};

careersPage.getInitialProps = async ({ session }) => {
  try {
    const careers = await getCareers(session);
    return {
      careers,
    };
  } catch (error) {
    console.error('Failed to load Knowledge Base', error);
    return { error };
  }
};

export default careersPage;
